var map = {
	"./wastebox_blue.min.png": "b032",
	"./wastebox_gray.min.png": "5c9c",
	"./wastebox_green.min.png": "5257",
	"./wastebox_orange.min.png": "7700",
	"./wastebox_yellow.min.png": "7fe3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23a3";